import React from "react";
// import logo from "../../../assets/common/logo.webp";
import logo from "../../../assets/common/logo_sunny.webp";

import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import imglogosunny from "../../../assets/common/logo_sunny_03.png";
import imglogosunny from "../../../assets/common/logo_sunny_03.png";

import { path } from "../../../utils/common/constant";
const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="max-w-[1140px] mx-auto pt-10 w-[80%]  qhd:max-w-[100%] qhd:w-[100%]">
      <div className="max-w-[1140px] qhd:max-w-[60%] mx-auto">
        <div className=" grid grid-cols-3 gap-10  pv:max-ph:pb-4 pv:max-ph:gap-0 pv:max-lg:grid-cols-1">
          <div className="flex flex-col justify-between items-start gap-4 ">
            <img
              className="md:w-[120px] w-[100px] qhd:w-[240px] max-md:mb-6"
              src={logo}
              alt="Logo"
            />
            <p className="text-[1rem] qhd:text-[1rem] text-primary text-left pv:max-sm:pb-4 text-justify">
              {t("FooterDescription")}
            </p>
          </div>

          {/* Pages and Contact wrapper */}
          <div className="col-span-2 grid grid-cols-1 gap-10 md:grid-cols-2">
            {/* Pages section */}
            <div className="flex gap-4 flex-col text-primary  items-center pv:max-md:items-start uppercase ">
              <p className="text-[1rem]  qhd:text-[1rem] font-bold mb-4  ph:flex ">
                {t("FooterPage")}
              </p>
              <div
                onClick={() => {
                  navigate("../" + path.common.HOME);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                <p className="text-start"> {t("FooterHome")}</p>
              </div>
              <div
                onClick={() => {
                  navigate("../" + path.common.ABOUT);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {t("FooterAboutUs")}
              </div>
              <div
                onClick={() => {
                  navigate("../" + path.common.SERVICES);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {t("FooterService")}
              </div>
              <div
                onClick={() => {
                  navigate("../" + path.common.BLOG);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {t("FooterCSR")}
              </div>
              <div
                onClick={() => {
                  navigate("../" + path.common.CAREER);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {t("HeaderCareer")}
              </div>
              <div
                onClick={() => {
                  navigate("../" + path.common.PARTNERS);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {t("HeaderPartners")}
              </div>
              {/* <div
                onClick={() => {
                  navigate("../" + path.common.SOKO);
                }}
                className="text-[1rem]  qhd:text-[1rem] hover:text-secondary1 cursor-pointer"
              >
                {"SOKO"}
              </div> */}
            </div>

            {/* Contact section */}
            <div className="flex flex-col gap-4 text-primary pvmax:max-dv:w-[85%] sm:pl-10 ">
              <p className="font-bold flex text-[1rem]   qhd:text-[1rem] uppercase ">
                {t("FooterContact")}
              </p>
              <div className="flex flex-col justify-between h-full gap-3">
                <div className="text-[1rem] qhd:text-[1rem] flex flex-col gap-3">
                  <div className="flex gap-2 justify-start items-center">
                    <p>{t("FooterAddress_01")}</p>
                  </div>
                  <div className="flex gap-2 justify-start items-center">
                    <a href="mailto:info@sunnypearl.com.vn">
                      info@sunnypearl.com.vn
                    </a>
                  </div>
                  <div className="flex gap-2 justify-start items-center">
                    <a href="mailto:info@idg-global.com">info@idg-global.com</a>
                  </div>

                  {/* <div className="flex gap-2 justify-start items-center">
                    <a href="mailto:investmentteam@idg.com">
                      investmentteam@idg-global.com
                    </a>
                  </div> */}
                  {/* <div className="flex gap-2 justify-start items-center">
                    <a href="tel:+84931780086">+ 84 93 178 00 86</a>
                  </div> */}
                  <div className="flex gap-2 justify-start items-center">
                    <a href="tel:+84938899017">+ 84 93 88 99 017</a>
                  </div>
                  {/* <div className="flex gap-2 justify-start items-center">
                    <a href="tel:+61481736827">+ 61 481 736 827</a>
                  </div> */}

                  {/* <div className="flex gap-2 justify-start items-center">
                    <span>{`${t("FooterTaxCode")}: `}</span>
                    <a href="">0314848457</a>
                  </div> */}
                </div>
                <div className="flex justify-start gap-4 text-primary">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/profile.php?id=61568578130590"
                    className="cursor-pointer"
                  >
                    <Icon className="h-6 w-6  " icon={"ri:facebook-fill"} />
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.linkedin.com/company/idg-australia/"
                    className="cursor-pointer"
                  >
                    <Icon className="h-6 w-6 " icon={"ri:linkedin-fill"} />
                  </a>
                  {/* <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://sunnypearl.com.vn/"
                    className="cursor-pointer"
                  >
                    <img className="h-6 w-6 " src={imglogosunny} />
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[0.5px] qhd:h-[1px] bg-primary max-w-[1140px] qhd:max-w-[60%] mx-auto mt-10 qhd:mt-16"></div>
      <div className="flex justify-center py-4 qhd:py-8">
        <div className="">
          <p className="text-primary cursor-pointer text-[1rem] qhd:text-[1rem]">
            © {new Date().getFullYear()} Sunny Pearl © All rights reserved by
            Sunny Pearl
          </p>
        </div>
        {/* <div className="flex justify-start gap-4 text-primary"></div> */}
      </div>
    </div>
  );
};

export default Footer;
